// AuthContextProvider.tsx

import React, { createContext, useEffect, useState, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface AuthContextProps {
    isAuthenticated: boolean;
    isLoading: boolean;
}

interface AuthProviderProps {
    children: ReactNode;
}

export const AuthContext = createContext({} as AuthContextProps);

export function AuthContextProvider({ children }: AuthProviderProps) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const location = useLocation();

    useEffect(() => {
        // Libera a aplicação quando há link de pagamento na URL (checkout com API key)
        // ou quando há authToken (fluxo legado).
        const params = new URLSearchParams(window.location.search);
        const authTokenFromUrl = params.get('authToken');
        const linkPagamentoId = params.get('linkPagamentoId');

        const allowed = !!(authTokenFromUrl || linkPagamentoId);
        setIsAuthenticated(allowed);
        setIsLoading(false);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const authTokenFromUrl = params.get('authToken');
        const linkPagamentoId = params.get('linkPagamentoId');
        const allowed = !!(authTokenFromUrl || linkPagamentoId);
        setIsAuthenticated(allowed);
    }, [location.search]);

    return (
        <AuthContext.Provider value={{ isAuthenticated, isLoading }}>
            {children}
        </AuthContext.Provider>
    );
}